import { shallowEqual, useSelector } from 'react-redux'
//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selector = (state) => state.worksheetReducer;

//  -- Examples array selector --------

export const useWorkSheetSelector = () => {
    const selectedData = useSelector(selector, shallowEqual)
    return selectedData;
}

//  -- Examples data ------------------
const imageSelector = (state) => state.worksheetImageReducer;

//  -- Examples array selector --------

export const useWorkSheetImageSelector = () => {
    const selectedData = useSelector(imageSelector, shallowEqual)
    return selectedData;
}
